import { useEffect, useRef, useState } from 'react';

// This is a public form destination, not an API secret. Never put private keys in REACT_APP_*.
export const CONTACT_ENDPOINT = process.env.REACT_APP_HEROTOFU_ENDPOINT || 'https://public.herotofu.com/v1/a8a1aeb0-0869-11ed-be50-e78da9ee852d';

export default function useEmail(endpoint = CONTACT_ENDPOINT) {
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');
  const request = useRef(null);

  useEffect(() => () => request.current?.abort(), []);

  async function sendEmail(data) {
    if (request.current) return false;
    const controller = new AbortController();
    request.current = controller;
    setStatus('sending');
    setError('');
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
        signal: controller.signal,
      });
      if (response.status === 422) {
        setStatus('verification');
        return false;
      }
      if (!response.ok) throw new Error(response.status === 429 ? 'Too many attempts. Please wait a few minutes and try again.' : 'Your message couldn’t be sent. Your draft is still here—please try again in a moment.');
      setStatus('success');
      return true;
    } catch (err) {
      setStatus('error');
      setError(err.name === 'AbortError' ? 'The request timed out. Please try again. Your draft is still here.' : err instanceof TypeError ? 'Couldn’t connect. Please check your internet connection and try again.' : err.message);
      return false;
    } finally {
      clearTimeout(timeout);
      request.current = null;
    }
  }

  function reset() { setStatus('idle'); setError(''); }
  return { status, error, sendEmail, reset };
}
